// Session 목록 reducer (Phase 2)
import { assignDisplayNumbers } from '../../utils/sessionDisplay';
// backend GET /sql-developer/sessions 결과를 보관. ephemeral=true 항목은 폴링 측에서
// 필터링되어 들어오지만 reducer 도 안전하게 한 번 더 필터링.

const SESSIONS_SET = 'SESSIONS_SET';
const SESSIONS_ERROR = 'SESSIONS_ERROR';
const SESSION_OPTIMISTIC_REMOVE = 'SESSION_OPTIMISTIC_REMOVE';
const SESSION_CREATED = 'SESSION_CREATED';

const initialState = {
    list: [],
    isPolling: false,
    lastFetchAt: null,
    error: null,
    // 세션 표시 번호표 { bySession: { [sessionId]: 번호 } } — 목록이 새로 와도 번호가 흔들리지 않게 이어받는다
    numbering: { bySession: {} },
};

const sessionReducer = (state = initialState, action) => {
    switch (action.type) {
        case SESSIONS_SET: {
            const payload = Array.isArray(action.payload) ? action.payload : [];
            const visible = payload.filter(s => !s.ephemeral);
            // 화면 이름 "세션 N" 의 번호를 여기서 한 번 매긴다 — 화면마다 세면 헤더·탐색기 번호가 갈린다
            const { list, numbering } = assignDisplayNumbers(state.numbering, visible);
            return { ...state, list, numbering, lastFetchAt: Date.now(), error: null };
        }
        case SESSIONS_ERROR:
            return { ...state, error: action.payload || 'unknown error' };
        case SESSION_OPTIMISTIC_REMOVE: {
            const sid = action.payload;
            return { ...state, list: state.list.filter(s => s.sessionId !== sid) };
        }
        case SESSION_CREATED: {
            // 방금 만든 세션을 **곧바로** 목록에 넣는다(2026-10-13). 예전에는 다음 폴링(쉴 때 3초)이 와야 보여서
            // + 를 누르면 한참 멈칫했다 — 서버는 0.02초 만에 만들어 놓고 화면만 기다리고 있었다. 다음 폴링이 서버 상태로 맞춘다
            const made = action.payload;
            if (!made || !made.sessionId || made.ephemeral || state.list.some(x => x.sessionId === made.sessionId)) return state;
            const { list, numbering } = assignDisplayNumbers(state.numbering, [...state.list, made]);
            return { ...state, list, numbering };
        }
        default:
            return state;
    }
};

export default sessionReducer;
export { SESSIONS_SET, SESSIONS_ERROR, SESSION_OPTIMISTIC_REMOVE, SESSION_CREATED };
